import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import {
  KeyboardArrowDown,
  CheckBoxOutlineBlank,
  CheckBox,
} from '@mui/icons-material'
import useReportsActions from '@/views/reports/hooks/use-reports-actions.hooks'

import { wageringSelector } from '@/state/wagering-contribution/slices/index.slices'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const GamesFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const { getAllGames } = useReportsActions()

  const { gamesList, isLoadingGames } = useSelector(wageringSelector)
  const [field] = useField('game')

  const optionsToGroup = gamesList?.map((g) => g.name) ?? []

  return (
    <FormControl fullWidth margin="dense">
      <Autocomplete
        fullWidth
        multiple
        disableClearable
        disableCloseOnSelect
        getLimitTagsText={(more) => (
          <Typography
            variant="caption"
            sx={{ fontWeight: 600 }}
          >{`+${more}`}</Typography>
        )}
        limitTags={3}
        clearOnBlur
        options={optionsToGroup}
        freeSolo
        value={
          Array.isArray(field.value)
            ? field.value
            : field.value
              ? [field.value]
              : []
        }
        className="green"
        onChange={(_, newValue: any | null) => {
          handleChangeSearch('game', newValue || [])
        }}
        onOpen={() => {
          if (gamesList === undefined || gamesList.length === 0) {
            getAllGames(true)
          }
        }}
        popupIcon={<KeyboardArrowDown />}
        renderOption={(props, option, { selected }) => {
          const isSelected = selected || field.value?.includes(option)
          return (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlank fontSize="small" />}
                checkedIcon={<CheckBox fontSize="small" />}
                style={{ marginRight: 8, padding: 0 }}
                checked={isSelected}
              />
              {option}
            </li>
          )
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip size="small" label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            label={t('labels.game')}
            placeholder={
              field.value && field.value.length > 0
                ? ''
                : t('reports.addGameName')
            }
            name="game"
          />
        )}
        PaperComponent={({ children, ...other }) => (
          <Box component={Paper} fontSize="12px!important" {...other}>
            {children}
          </Box>
        )}
      />
      {isLoadingGames && (
        <Box position="absolute" right={15} top={8}>
          <CircularProgress variant="indeterminate" size={30} />
        </Box>
      )}
    </FormControl>
  )
}
export default GamesFilterType
